import { Paperclip } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

const FILE_VIEW_COMING_SOON = 'Viewing the files is coming soon';

export function DonationFileIcon() {
  return (
    <Tooltip>
      <TooltipTrigger
        render={<span tabIndex={0} aria-label={`Has files. ${FILE_VIEW_COMING_SOON}`} />}
        className="inline-flex cursor-help text-muted-foreground"
      >
        <Paperclip className="size-4" aria-hidden />
      </TooltipTrigger>
      <TooltipContent>{FILE_VIEW_COMING_SOON}</TooltipContent>
    </Tooltip>
  );
}
